import { Account } from '@/domain/usecases'
import errorMonitor from '@/infra/tracking/error-monitor'
import { Spinner } from '@/presentation/components'
import GenericError from '@/presentation/components/ui/feedback/generic-error'
import MainLayout from '@/presentation/components/ui/layout/main-layout'
import { ValidAccountState } from '@/presentation/contexts/auth/account-provider'
import useAccount from '@/presentation/hooks/auth/use-account'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import AuthenticatedRoutesBuilder from './builders/authenticated-routes-builder'
import UnauthenticatedRoutesBuilder from './builders/unauthenticated-routes-builder'
import RouterMiddleware from './router-middleware'

export default function RouterFactory(): JSX.Element {
  const [account] = useAccount() as ValidAccountState
  const wrappedCreateBrowserRouter = errorMonitor.wrapCreateBrowserRouter(createBrowserRouter)
  const createdRouter = Account.isAnonnimous(account)
    ? UnauthenticatedRoutesBuilder()
    : AuthenticatedRoutesBuilder()

  return (
    <RouterProvider
      router={wrappedCreateBrowserRouter(
        [
          {
            element: (
              <RouterMiddleware>
                <MainLayout />
              </RouterMiddleware>
            ),
            errorElement: <GenericError fullScreen />,
            children: createdRouter
          }
        ],
        {
          future: {
            v7_normalizeFormMethod: true
          }
        }
      )}
      fallbackElement={<Spinner fullScreen />}
    />
  )
}
